import { SoundsInfo } from "../Lists/SoundInfo";

const Sound = ({ togglePlay, sounds, volumes, setVolume, playingSounds, isPaused }) => {

  return SoundsInfo.map((sound, index) => {
    return (
      <div
        title={sound.Name}
        key={index}
        className="sound-tile"
      >
        <button 
          onClick={() => togglePlay(index)} 
          className={`sound-button ${playingSounds.includes(index) ? "is-selected" : ""}`}
          aria-label={playingSounds.includes(index) ? `${isPaused ? "Remove" : "Stop"} ${sound.Name}` : `${isPaused ? "Add" : "Play"} ${sound.Name}`}
          aria-pressed={playingSounds.includes(index)}
        >
          {sound.Icon}
        </button>
        <div>
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            key={index}
            value={volumes?.[index] ?? 0.5}
            onChange={(e) =>
              setVolume(sounds[index], parseFloat(e.target.value), index)
            }
            aria-label={`${sound.Name} volume`}
            className={`mt-4 w-24 h-2 appearance-none rounded-full bg-white/30 transition-all duration-300 
              focus:outline-none focus:ring-2 focus:ring-white/50
              [&::-webkit-slider-thumb]:appearance-none 
              [&::-webkit-slider-thumb]:w-4 
              [&::-webkit-slider-thumb]:h-4 
              [&::-webkit-slider-thumb]:rounded-full 
              [&::-webkit-slider-thumb]:bg-white 
              [&::-webkit-slider-thumb]:shadow-md 
              [&::-webkit-slider-thumb]:border 
              [&::-webkit-slider-thumb]:border-white

              [&::-moz-range-thumb]:appearance-none 
              [&::-moz-range-thumb]:w-4 
              [&::-moz-range-thumb]:h-4 
              [&::-moz-range-thumb]:rounded-full 
              [&::-moz-range-thumb]:bg-white 
              [&::-moz-range-thumb]:border 
              [&::-moz-range-thumb]:border-white ${
                playingSounds.includes(index) ? "block" : "hidden"
              }`}
          />
        </div>
      </div>
    );
  });
};

export default Sound;
